export const GUIDED_INTAKE_PROMO_EVENTS = {
  DISMISSED: 'Guided Intake Promo Dismissed',
} as const

/**
 * Fullstory custom events for the Guided Intake funnel, reached through the
 * Segment -> Fullstory destination. Names are fixed by the instrumentation
 * spec: the Fullstory funnels are configured against these exact strings.
 */
export const GUIDED_INTAKE_EVENTS = {
  CONVERSATION_STARTED: 'gi_conversation_started',
  USER_TURN: 'gi_user_turn',
  RESULTS_RENDERED: 'gi_results_rendered',
  ITEM_SELECTED: 'gi_item_selected',
  DRAFT_OR_CREATED: 'gi_draft_or_created',
  CHECKOUT_REDIRECT: 'gi_checkout_redirect',
} as const

export const SMART_SEARCH_EVENTS = {
  RESULTS_RENDERED: 'ss_results_rendered',
  RESULT_CLICKED: 'ss_result_clicked',
} as const
